import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const buyers = [{
  name: 'Mariana',
  city: 'Buenos Aires'
}, {
  name: 'Soledad',
  city: 'Córdoba'
}, {
  name: 'Paula',
  city: 'Rosario'
}, {
  name: 'Daniela',
  city: 'Mendoza'
}, {
  name: 'Florencia',
  city: 'La Plata'
}, {
  name: 'Romina',
  city: 'Salta'
}, {
  name: 'Gabriela',
  city: 'Tucumán'
}, {
  name: 'Andrea',
  city: 'Mar del Plata'
}, {
  name: 'Natalia',
  city: 'Santa Fe'
}, {
  name: 'Cecilia',
  city: 'Neuquén'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  const [isInPurchaseSection, setIsInPurchaseSection] = useState(false);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  // Observe the purchase section visibility
  useEffect(() => {
    const purchaseEl = document.getElementById('compra');
    if (!purchaseEl) return;
    const observer = new IntersectionObserver(([entry]) => {
      setIsInPurchaseSection(entry.isIntersecting);
    }, {
      threshold: 0.1
    });
    observer.observe(purchaseEl);
    return () => observer.disconnect();
  }, []);
  // Show popups every 15 seconds only when purchase section is visible
  useEffect(() => {
    if (isInPurchaseSection) {
      // Show immediately when entering section
      showPopup();
      // Then every 15 seconds
      intervalRef.current = setInterval(() => {
        showPopup();
      }, 15000);
    } else {
      // Hide and stop when leaving section
      setIsVisible(false);
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    }
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [isInPurchaseSection]);
  const showPopup = () => {
    const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
    setCurrentBuyer(randomBuyer);
    setIsVisible(true);
    // Hide after 4 seconds
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setIsVisible(false);
    }, 4000);
  };
  return <AnimatePresence data-id="element-345">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50,
      x: -20
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-xl border border-gray-100 p-4 max-w-xs flex items-center gap-3" data-id="element-346">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-347">
            <CheckIcon className="w-5 h-5 text-green-600" data-id="element-348" />
          </div>
          <div data-id="element-349">
            <p className="text-sm text-gray-800 font-medium" data-id="element-350">
              <span className="font-bold" data-id="element-351">{currentBuyer.name}</span> de{' '}
              {currentBuyer.city} acaba de comprar Megapack ESI Secundaria
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-352">Hace unos minutos</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}